import { useQuery } from "@tanstack/react-query"
import { useApi } from "../views/hooks/useApi"

export const useSearchDatasets = (searchTerm: string) => {
  const { scientApi } = useApi()

  const { data, error, isLoading } = useQuery({
    queryKey: ["datasetSearch", searchTerm],
    queryFn: () => scientApi.trading.searchDatasets(searchTerm),
    enabled: searchTerm.length >= 3,
    select: data => data ?? [],
  })

  return { data, error, isLoading }
}
